<template>
  <div class="form-group places-input-group">
    <slot name="before"></slot>
    <input class="form-control" type="text" autocomplete="off"
    :id="attrs.id"
    :placeholder="attrs.placeholder"
    :disabled="attrs.disabled"
    :value="inputValue"
    @input="input"
    @focus="focus"
    @keydown.up="up"
    @keydown.down="down"
    @keydown.enter.stop.prevent="enter"
    @keydown.esc.stop.prevent="triggerBlur"
    @blur="blur"/>
    <div class="dropdown-menu-container">
      <ul :class="{'show': showDropdown}" class="dropdown-menu">
        <li v-for="(p, index) in places"
            :class="{'selected': index === selectedPlace}"
            @mousemove="setSelected(index)"
            @mousedown.prevent="fetchPlace(p)">{{p.description}}
        </li>
      </ul>
    </div>
    <slot name="after"></slot>
  </div>
</template>

<script>
// Google places autocomplete input component

import Places from '../../services/maps/PlacesApi.js'
import debounce from 'lodash.debounce'

export default {
  data: function () {
    return {
      inputBuffer: '',
      placesAPIList: '',
      selectedPlace: 0,
      showDropdown: false,
      inFocus: false
    }
  },
  props: ['attrs', 'position'],
  methods: {
    input: function (event) {
      this.inputBuffer = event.target.value  // save the user's input into the buffer
      if (this.inputBuffer) {
        this.processInput()
      }
    },
    processInput: debounce(function () {
      if (this.inputBuffer) {
        Places.autocomplete(this.inputBuffer).then((result) => {
          this.placesAPIList = result
          this.$nextTick(function () {
            this.showDropdown = typeof this.places !== 'undefined' && this.places.length > 0
          })
        })
      }
    }, 100),
    fetchPlace (place) {
      if (place) {
        Places.details(place.place_id).then((result) => {
          // propagate the result to the parent component
          this.$emit('place-selected', {
            lat: result.geometry.location.lat,
            long: result.geometry.location.lng,
            address: result.formatted_address
          })
          this.inputBuffer = '' // reset the input buffer
          this.triggerBlur() // blur the field (also calls this.blur())
        })
      }
    },
    setSelected (i) {
      this.selectedPlace = i
    },
    up () {
      this.selectedPlace = this.selectedPlace === 0 ? this.selectedPlace : this.selectedPlace - 1
    },
    down () {
      this.selectedPlace = this.selectedPlace === this.places.length - 1 ? this.selectedPlace : this.selectedPlace + 1
      if (this.showDropdown === false) {
        this.processInput()
      }
    },
    enter () {
      this.fetchPlace(this.places[this.selectedPlace])
    },
    focus () {
      this.inFocus = true
      this.processInput()
    },
    triggerBlur () {
      let el = document.getElementById(this.attrs.id)
      el.blur()
    },
    blur () {
      this.inFocus = false
      this.showDropdown = false
      this.selectedPlace = 0
    },
    formatCoordinates: function (lat, long) {
      return `${this.$t('map.coordinates')} \
${Math.abs(lat).toFixed(2)}°${lat >= 0 ? 'N' : 'S'}, \
${Math.abs(long).toFixed(2)}°${long >= 0 ? 'E' : 'W'}`
    }
  },
  computed: {
    inputValue: function () {
      if (this.inFocus) {
        return this.inputBuffer
      } else {
        if (this.position) {
          if (this.position.address) {
            return this.position.address
          } else if (this.position.lat !== 0 && this.position.long !== 0) {
            return this.formatCoordinates(this.position.lat, this.position.long)
          }
        }
      }
      // in all other cases
      return ''
    },
    places: function () {
      if (this.placesAPIList.length) {
        return this.placesAPIList.filter(function (p) {
          return p.place_id !== undefined
        })
      }
    }
  }
}
</script>

<style scoped>
.dropdown-menu li {
  cursor: pointer;
}
</style>
